import { debugMessage } from '../debug.js';
import { logger } from '../logger.js';

/**
 * setupLazyLoading enables lazyLoading if it is enabled
 * @param {Object} lazyLoading
 */
export const setupGptLazyLoading = ({ lazyLoading }) => {
  debugMessage('Lazy loading settings:', { lazyLoading });
  if (lazyLoading?.enabled) {
    try {
      googletag.pubads().enableLazyLoad(lazyLoading);
    } catch (e) {
      googletag.pubads().collapseEmptyDivs();
      logger.error(`Enabling lazy loading failed: ${e.message}`);
    }
  } else {
    googletag.pubads().collapseEmptyDivs();
  }
};

/**
 * Enables all GPT services that have been defined for ad slots on the page.
 */
export const enableGptServices = () => {
  googletag.enableServices();
};

/**
 * Refresh the ads.
 */
export const refreshAds = (slots) => {
  googletag.cmd.push(() => {
    googletag.pubads().refresh(slots);
  });
};

/**
 * Request ads using the default GPT functionality (i.e. no header bidders).
 */
export const defaultRequest = (slots) => slots.map((slot) => googletag.display(slot));
